import { useLang } from '@common/context/language-provider';
import { SpaceAdminRoutes } from '@routes/space-admin-routes';
import { SpaceRoutes } from '@routes/space-routes';
import { SurveyRoutes } from '@routes/survey-routes';
import { generatePath, useMatch } from 'react-router';

export const useSupportUrl = () => {
  const { language: lang } = useLang();
  const isAdminRoute = useMatch('/:lang/admin/*');
  const isSurveyRoute = useMatch('/:lang/:surveySlug/*');
  const isSpaceRoute = useMatch('/:lang/:page');
  const isSurveyAdminRoute = useMatch('/:lang/:surveySlug/admin/*');


  if (isAdminRoute) {
    return generatePath(SpaceAdminRoutes.Support, { lang });
  }

  if (isSurveyAdminRoute) {
    return generatePath(SurveyRoutes.AdminSupport, { lang, surveySlug: isSurveyAdminRoute.params.surveySlug! });
  }

  if (isSpaceRoute) {
    return generatePath(SpaceRoutes.support, { lang });
  }

  if (isSurveyRoute) {
    return generatePath(SurveyRoutes.ParticipantSupport, { lang, surveySlug: isSurveyRoute.params.surveySlug! });
  }

  return generatePath(SpaceRoutes.support, { lang });

};